import { Component } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { nuc } from '../../utils';
import { icons, IconText } from '../generic/Icon';
import Link from '../generic/Link/Link';

export default class ModalShareProject extends Component<{
  locator: string;
  show: boolean;
  onHide: Function;
}, {
  copied: boolean;
}> {
  constructor(props) {
    super(props);
    this.state = { copied: false };
  }

  get shareUrl(): string {
    const { origin } = window.location;
    const { locator } = this.props;
    return `${origin}/projects/${nuc(locator)}`;
  }

  sharePhrase = encodeURIComponent('I just scanned my open source dependencies with FOSSA!');

  render() {
    return (
      <Modal backdrop animation show={this.props.show} onHide={this.props.onHide}>
        <Modal.Header closeButton>
          <Modal.Title className="text-center">Share Dependency Report</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <CopyToClipboard text={`${this.shareUrl}?utm_source=share_link`} onCopy={() => this.setState({ copied: true })}>
            <Button className="btn-card">
              <IconText
                text={this.state.copied ? 'Copied!' : 'Copy Link'}
                icon={icons.link}
              />
            </Button>
          </CopyToClipboard>
          &nbsp;
          <Link
            className="btn btn-twitter-share"
            to={`https://twitter.com/intent/tweet?text=${this.sharePhrase}&via=getfossa&url=${this.shareUrl}`}
            openInNewTab
          >
            Tweet
          </Link>
          &nbsp;
          <Link
            className="btn btn-facebook-share"
            to={`https://www.facebook.com/sharer/sharer.php?u=${this.shareUrl}`}
            openInNewTab
          >
            Share on Facebook
          </Link>
          <br /><br />
        </Modal.Body>
      </Modal>
    );
  }
}
